export const RegionStates = [
  { text: 'AK', label: 'Alaska' },
  { text: 'AL', label: 'Alabama' },
  { text: 'AR', label: 'Arkansas' },
  { text: 'AZ', label: 'Arizona' },
  { text: 'CA', label: 'California' },
  { text: 'CO', label: 'Colorado' },
  { text: 'CT', label: 'Connecticut' },
  { text: 'DC', label: 'District of Columbia' },
  { text: 'DE', label: 'Delaware' },
  { text: 'FL', label: 'Florida' },
  { text: 'GA', label: 'Georgia' },
  { text: 'HI', label: 'Hawaii' },
  { text: 'IA', label: 'Iowa' },
  { text: 'ID', label: 'Idaho' },
  { text: 'IL', label: 'Illinois' },
  { text: 'IN', label: 'Indiana' },
  { text: 'KS', label: 'Kansas' },
  { text: 'KY', label: 'Kentucky' },
  { text: 'LA', label: 'Louisiana' },
  { text: 'MA', label: 'Massachusetts' },
  { text: 'MD', label: 'Maryland' },
  { text: 'ME', label: 'Maine' },
  { text: 'MI', label: 'Michigan' },
  { text: 'MN', label: 'Minnesota' },
  { text: 'MO', label: 'Missouri' },
  { text: 'MS', label: 'Mississippi' },
  { text: 'MT', label: 'Montana' },
  { text: 'NC', label: 'North Carolina' },
  { text: 'ND', label: 'North Dakota' },
  { text: 'NE', label: 'Nebraska' },
  { text: 'NH', label: 'New Hampshire' },
  { text: 'NJ', label: 'New Jersey' },
  { text: 'NM', label: 'New Mexico' },
  { text: 'NV', label: 'Nevada' },
  { text: 'NY', label: 'New York' },
  { text: 'OH', label: 'Ohio' },
  { text: 'OK', label: 'Oklahoma' },
  { text: 'OR', label: 'Oregon' },
  { text: 'PA', label: 'Pennsylvania' },
  { text: 'RI', label: 'Rhode Island' },
  { text: 'SC', label: 'South Carolina' },
  { text: 'SD', label: 'South Dakota' },
  { text: 'TN', label: 'Tennessee' },
  { text: 'TX', label: 'Texas' },
  { text: 'UT', label: 'Utah' },
  { text: 'VA', label: 'Virginia' },
  { text: 'VT', label: 'Vermont' },
  { text: 'WA', label: 'Washington' },
  { text: 'WI', label: 'Wisconsin' },
  { text: 'WV', label: 'West Virginia' },
  { text: 'WY', label: 'Wyoming' }
];

// Create lookup maps for O(1) retrieval
const stateAbbreviationMap = new Map<string, string>();
const stateNameMap = new Map<string, string>();

RegionStates.forEach(({ text, label }) => {
  stateAbbreviationMap.set(text.toLowerCase(), label);
  stateNameMap.set(label.toLowerCase(), text);
});

export const getStateInfo = (input: string): string | undefined => {
  const normalizedInput = input.trim().toLowerCase();
  return stateAbbreviationMap.get(normalizedInput) || stateNameMap.get(normalizedInput);
};
